import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net";
import { Modal } from "react-bootstrap";
import axiosClient from "../../../axios-client";
import Navbar from "../Navbar";
import SideBar from "../SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const AdminContactus = () => {
  const dataTableRef = useRef();
  const navigate = useNavigate();

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [editContact, setEditContact] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [newContact, setNewContact] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const fetchContacts = async () => {
    try {
      const response = await axiosClient.get("/contactus/getdetails");

      if (response.status === 200) {
        setContacts(response.data);
        setLoading(false);
        console.log(response.data);

        // Initialize DataTable after data is loaded
        if (dataTableRef.current) {
          $(dataTableRef.current).DataTable({
            destroy: true, // Re-initialize DataTable for dynamic updates
            order: [[0, "asc"]],
          });
        }
      } else {
        throw new Error("Failed to fetch contact messages.");
      }
    } catch (err) {
      setError(
        err.message || "Failed to fetch contact messages. Please try again."
      );
      setLoading(false);
    }
  };

  // Fetch all contact messages on component mount
  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);
  // Handle showing the edit modal with selected contact data
  const handleShowEdit = (contact) => {
    setSelectedContactId(contact?._id);
    setEditContact({
      name: contact?.name || "",
      email: contact?.email || "",
      phone: contact?.phone || "",
      message: contact?.message || "",
    });
  };

  // Show Add Contact Modal
  const handleShowAdd = () => {
    setNewContact({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
    setError("");
  };

  const handleDeleteContact = async (contactId) => {
    
      try {
        const response = await axiosClient.delete(
          `/contactus/delete/${contactId}`
        );
        if (response.status === 200) {
          alert("Contact deleted successfully!");
          fetchContacts(); // Refresh contacts after deletion
        } else {
          throw new Error("Failed to delete the contact.");
        }
      } catch (error) {
        alert(error.message || "An error occurred while deleting the contact.");
      }
    
  };

  return (
    <>
      <SideBar />
      <Navbar />
      <section className="home">
        <div className="toggle-sidebar" style={{ display: "none" }}>
          <i className="bi bi-menu"></i>
        </div>

        <div className="container">
          <div className="row foot-tablerow">
            <div className="heading-and-button">
              <h5>Contact Messages</h5>
              {/* <div className="add-button" style={{ marginBottom: "20px" }}>
                <button onClick={handleShowAdd} className="btn btn-primary">
                  + Add Contact
                </button>
              </div> */}
            </div>

            <div className="col-lg-12 maintable-column">
              <div className="container mt-4 overflow-auto">
                {loading ? (
                  <p>Loading...</p>
                ) : error ? (
                  <p className="text-danger">{error}</p>
                ) : (
                  <table
                    id="datatable"
                    className="table table-striped table-bordered"
                    ref={dataTableRef}
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Actions</th> {/* Added Actions column */}
                      </tr>
                    </thead>
                    <tbody>
                      {contacts.map((contact, index) => (
                        <tr key={contact._id}>
                          <td>{index + 1}</td>
                          <td>{contact.name}</td>
                          <td>{contact.email}</td>
                          <td>{contact.mobileNumber}</td>
                          <td>{contact.message}</td>
                          <td>
                            {/* Actions Buttons */}

                            <button
                              className="btn btn-sm btn-danger justify-content-center"
                              onClick={() => handleDeleteContact(contact._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdminContactus;
